export default "__VITE_ASSET__D8cn1Uch__"